import { BlockLabellingPattern } from '@storage/app/api'
import { SelectOption } from '@storage/app/models'
import { EnumAsSelectOptionsUtil } from '@storage/utils/enums'
import { useMemo } from 'react'

const KEY_PREFIX = 'bayRowLabelingPattern'

export const useLabelingPatternOptions = (): SelectOption[] =>
  useMemo(
    () =>
      EnumAsSelectOptionsUtil.transform(BlockLabellingPattern, KEY_PREFIX).map(option => ({
        ...option,
        label: option.label,
      })),
    [],
  )
